<template>
	<div class="row">
		<div class="col-md-12">
			<section class="panel">
				<header class="panel-heading">
					<h2 class="panel-title">入宿資料</h2>
				</header>
				<div>
					<div class="panel-body container-fluid">
						<div class="form-group">
							<div class="row form-group">
								<div class="col-md-4 form-group">
									<label class="col-xs-3 col-md-5">身份證號：</label>
									{{idno}}
								</div>
								<div class="col-md-4 form-group">
									<label class="col-xs-3 col-md-5">學&emsp;&emsp;制：</label>
									{{deptSsymStr}}
								</div>
								<div class="col-md-4 form-group">
									<label class="col-xs-3 col-md-5">性&emsp;&emsp;別：</label>
									{{sex}}
								</div>
							</div>

							<div class="row form-group">
								<div class="col-md-4 form-group">
									<label class="col-xs-3 col-md-5">姓&emsp;&emsp;名：</label>
									{{name}}
								</div>
								<div class="col-md-4 form-group">
									<label class="col-xs-3 col-md-5">科系班級：</label>
									{{deptCodeStr}} {{drade}} 年 {{dradeClass}} 班
								</div>
								<div class="col-md-4 form-group">
									<label class="col-xs-3 col-md-5">宿&emsp;&emsp;舍：</label>
									{{bedRoom}}{{bedFloor}}-{{bed}}-{{bedCategory}}
								</div>
							</div>

						<div class="row form-group">
							<div class="col-md-4 form-group">
								<label class="col-xs-3 col-md-5">聯絡電話：</label>
								{{tel}}
							</div>
							<div class="col-md-4 form-group">
								<label class="col-xs-3 col-md-5">行動電話：</label>
								{{phone}}
							</div>
							<div class="col-md-4 form-group">
								<label class="col-xs-3 col-md-5">資訊盒編號：</label>
								{{infoBoxNo}}
							</div>
						</div>

						<div class="row form-group">
							<div class="col-md-4 form-group">
								<label class="col-xs-3 col-md-5">常用信箱：</label>
								{{extMail}}
							</div>
							<div class="col-md-4 form-group">
								<label class="col-xs-3 col-md-5">學校信箱：</label>
								{{schMail}}
							</div>
							<div class="col-md-4 form-group">
								<label class="col-xs-3 col-md-5">電腦IP位置：</label>
								{{ipAddr}}
							</div>
						</div>

						<div class="row form-group">
							<div class="col-md-4 form-group">
								<label class="col-xs-3 col-md-5">電腦MAC位置：</label>
								<div class="col-xs-9 col-md-7" v-if="sessionData.accountType === 'STU'">
									<input type="text" name="macAddr" v-model="macAddr" placeholder="電腦MAC位置" class="form-control" />
									<!-- <span class="text-danger" v-show="errors.has('macAddr')" >{{ errors.first('macAddr') }}</span> -->
								</div>
								<label class="col-xs-9 col-md-7" v-else >{{macAddr}}</label>
							</div>
							<div class="col-md-4 form-group">
								<label class="col-xs-3 col-md-5">入宿日期：</label>
								<div class="col-xs-9 col-md-7" >
									<datepicker v-if="isAdmin('stay')" :format="customFormatter" :language="zh" v-validate="'required'" :disabled-dates="state.disabledDates" input-class="form-control" 
										placeholder="入宿日期" :style="{width:'auto', display:'inline-block'}" v-model="intoRoomDate"/>
									<span v-else>{{intoRoomDateCht}}</span>
								</div>
							</div>
							<div class="col-md-4 form-group"></div>
						</div>

						<div class="row form-group">
							<div class="col-md-12 form-group">
								<label class="col-xs-6 col-md-3 column-required">學生證正面上傳：</label>
								<label class="col-xs-6 col-md-3" for="stuCardPositFile" v-if="sessionData.accountType === 'STU'">
									<div style="display:none;">
										<input type="file" id="stuCardPositFile" style="width: 100%" accept=".pdf, image/*" ref="stuCardPosit" key="stuCardPosit-file" @change="getStuCardPosit($event)" />
										<input type="hidden" name="stuCardPosit" v-model="stuCardPosit" key="stuCardPosit-input" v-validate="'required'" />
									</div>
									<a class="btn btn-default">請選擇檔案</a>
									<span class="text-danger" v-show="errors.has('stuCardPosit')" >{{ errors.first('stuCardPosit') }}</span>
								</label>
								<p>
									{{stuCardPosit}}
									<a v-if="stuCardPositPreviewPDF" :href="stuCardPositPreviewPDF" style="color: #337ab7" target="_blank" >檔案預覽</a>
								</p>
							</div>
							<div class="col-xs-offset-util-3 col-xs-6 col-md-offset-util-3 col-md-6" v-if="stuCardPositPreview" >
								<img class="img-fluid" :src="stuCardPositPreview" alt style="width:200px; height:200px;" />
							</div>
						</div>

						<div class="row form-group">
							<div class="col-md-12 form-group">
							<label class="col-xs-6 col-md-3 column-required">學生證反面上傳：</label>
							<label class="col-xs-6 col-md-3" for="stuCardReverFile" v-if="sessionData.accountType === 'STU'">
								<div style="display:none;">
									<input type="file" id="stuCardReverFile" style="width: 100%" accept=".pdf, image/*" ref="stuCardRever" key="stuCardRever-file" @change="getStuCardRever($event)" />
									<input type="hidden" name="stuCardRever" v-model="stuCardRever" key="stuCardRever-input" v-validate="'required'" />
								</div>
								<a class="btn btn-default">請選擇檔案</a>
								<span class="text-danger" v-show="errors.has('stuCardRever')" >{{ errors.first('stuCardRever') }}</span>
							</label>
							<p>
								{{stuCardRever}}
								<a v-if="stuCardReverPreviewPDF" :href="stuCardReverPreviewPDF" style="color: #337ab7" target="_blank" >檔案預覽</a>
							</p>
							</div>
							<div class="col-xs-offset-util-3 col-xs-6 col-md-offset-util-3 col-md-6" v-if="stuCardReverPreview" >
								<img class="img-fluid" :src="stuCardReverPreview" alt style="width:200px; height:200px;" />
							</div>
						</div>
						</div>
						<div class="row form-group">
							<div class="col-md-2 form-group col-md-offset-4">
								<a @click="clickPrevious" class="btn s_btn_g btn-block">返回</a>
							</div>
							<div class="col-md-2 form-group">
								<a @click="handleSave" class="btn btn-primary btn-block">儲存</a>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			stuBase:{},
			dormitoryApply:{},
			accountType:"",
			deptSsymStr: "",
			deptCodeStr: "",
			sex: "",
			idno:"",
			name: "",
			dradeClass: "",
			phone: "",
			tel: "",
			infoBoxNo: "",
			drade: "",
			extMail: "",
			schMail: "",
			ipAddr: "",
			macAddr: "",
			bedFloor: "",
			bedRoom: "",
			bedCategory: "",
			bed: "",
			stuCardPosit: "",
			stuCardRever: "",
			stuCardPositPreview: null,
			stuCardReverPreview: null,
			stuCardPositPreviewPDF: "",
			stuCardReverPreviewPDF: "",
			stuCardPositFile: null,
			stuCardReverFile: null,
			intoRoomDate: null,
			intoRoomDateCht:"",
			isExpired:false,
			storeData:{
				dormitoryType:"", 
				idno:"", 
				smtr:"", 
				account:"",
			},
			state:{
				disabledDates:{
					to: this.toDate()
				}
			},
		};
	},
	mounted() {
		if (this.getStore(this.$route.name) != null) {
			this.storeData = JSON.parse(this.getStore(this.$route.name));
		}
		let _this = this;
		this.getRoomApplyInfo();
	},
	methods: {
		getRoomApplyInfo() {
			const applyInfoParams = {
				account: this.storeData.account,
				idno: this.storeData.idno,
				id:this.storeData.id,
				
			};
			const api = "/api/Room/roomInfo/";
			this.$axios.post(api, applyInfoParams).then(resp => {
				if(!this.jsonIsEmpty(resp.data.data.stuBase)){
					this.stuBase = resp.data.data.stuBase;
					this.account = resp.data.data.stuBase.account;
					this.idno = resp.data.data.stuBase.idno;
					this.sex = resp.data.data.stuBase.sexStr;
					this.tel = resp.data.data.stuBase.tel;
					this.phone = resp.data.data.stuBase.phone;
					this.dradeClass = resp.data.data.stuBase.dradeClass;
					this.drade = resp.data.data.stuBase.drade;
					this.schMail = resp.data.data.stuBase.schMail;
					this.extMail = resp.data.data.stuBase.extMail;
					this.name = resp.data.data.stuBase.name;
					this.deptSsymStr = resp.data.data.stuBase.deptSsymStr;
					this.deptCodeStr = resp.data.data.stuBase.deptCodeStr;
				}
				if(resp.data.data.dormitoryApply){
					this.dormitoryApply = resp.data.data.dormitoryApply;
					this.smtr = resp.data.data.dormitoryApply.smtr;
					this.dormitoryType = resp.data.data.dormitoryApply.dormitoryType;
					this.infoBoxNo = resp.data.data.dormitoryApply.infoBoxNo;
					this.ipAddr = resp.data.data.dormitoryApply.ipAddr;
					this.bed = resp.data.data.dormitoryApply.bed;
					this.bedFloor = resp.data.data.dormitoryApply.bedFloor;
					this.bedRoom = resp.data.data.dormitoryApply.bedRoom;
					this.bedCategory = resp.data.data.dormitoryApply.bedCategory;
					this.writeOffStatus = resp.data.data.dormitoryApply.writeOffStatus;
					this.macAddr = resp.data.data.dormitoryApply.macAddr;
					this.intoRoomDate = resp.data.data.dormitoryApply.intoRoomDate;
					this.intoRoomDateCht = this.customFormatter(resp.data.data.dormitoryApply.intoRoomDate);
					this.isExpired = (new Date() >= resp.data.data.dormitoryApply.intoRoomDate);
					
					if (resp.data.data.dormitoryApply.stuCardPosit) {
						this.stuCardPosit = resp.data.data.dormitoryApply.stuCardPosit;
						if (this.stuCardPosit.split(".")[1] === "pdf") {
							this.stuCardPositPreviewPDF = "/upload/" + this.stuCardPosit;
						} else {
							this.stuCardPositPreview = "/upload/" + this.stuCardPosit;
						}
					}

					if (resp.data.data.dormitoryApply.stuCardRever) {
						this.stuCardRever = resp.data.data.dormitoryApply.stuCardRever;
						if (this.stuCardRever.split(".")[1] === "pdf") {
							this.stuCardReverPreviewPDF = "/upload/" + this.stuCardRever;
						} else {
							this.stuCardReverPreview = "/upload/" + this.stuCardRever;
						}
					}
					if(this.sessionData.accountType == "STU"){
						if (this.writeOffStatus !== "Y") {
							bootbox.alert("尚未繳費,請先繳費");
							this.$router.go(-1)
						}
					}	
				}
			});
		},

		getStuCardPosit(event) {
			let self = this
			this.stuCardPositFile = event.target.files[0];
			if(this.stuCardPositFile){
				if(this.checkFileExtension(this.stuCardPositFile.name, ["jpg","jpeg","png","pdf"])){
					this.stuCardPosit = this.stuCardPositFile.name;
					this.stuCardPositPreview = null;
					this.imgPreview(event.target.files[0]).then(result =>{
						self.stuCardPositPreview = result;
					}).catch(reason =>{
						self.stuCardPositFile = null;
						self.stuCardPosit = "";
						bootbox.alert("上傳失敗，請重新上傳。");
					});
					if (/^image/.test(this.stuCardPositFile.type)){
						this.compresImage(this.stuCardPositFile).then(result => {
							this.stuCardPositFile = result;
						});
					}
				}else{
					bootbox.alert("請上傳，下列格式: jpg, jpeg, png, pdf");
					this.stuCardPositFile = null;
				}
			}else{
				bootbox.alert("上傳失敗，請重新上傳。");
			}
		},
		getStuCardRever(event) {
			let self = this;
			this.stuCardReverFile = event.target.files[0];
			if(this.stuCardReverFile){
				if(this.checkFileExtension(this.stuCardReverFile.name, ["jpg","jpeg","png","pdf"])){
					this.stuCardRever = this.stuCardReverFile.name;
					this.stuCardReverPreview = null;
					this.imgPreview(event.target.files[0]).then(result =>{
						self.stuCardReverPreview = result;
					}).catch(reason =>{
						self.stuCardReverFile = null;
						self.stuCardRever = "";
						bootbox.alert("上傳失敗，請重新上傳。");
					});
					if (/^image/.test(this.stuCardReverFile.type)){
						this.compresImage(this.stuCardReverFile).then(result => {
							this.stuCardReverFile = result;
						});
					}
				}else{
					bootbox.alert("請上傳，下列格式: jpg, jpeg, png, pdf");
					this.stuCardReverFile = null;
				}
			}else{
				bootbox.alert("上傳失敗，請重新上傳。");
			}
		},
		clickPrevious() {
			this.$router.go(-1);
		},
		handleSave() {
			this.$validator.validateAll().then(result => {
				if (result) {
					const api = "/api/Room/saveIntoRoomData";
					const config = {
						headers: { "Content-Type": "multipart/form-data" }
					};

					let formData = new FormData();
					formData.append("id",this.dormitoryApply.id);
					formData.append("stuCardPositFile", this.stuCardPositFile);
					formData.append("stuCardReverFile", this.stuCardReverFile);
					formData.append("macAddr", this.macAddr);
					if(this.intoRoomDate){
						formData.append("intoRoomDate", this.customFormatter(this.intoRoomDate));
					}
					this.$axios.post(api, formData, config).then(resp => {
						if (resp.data.status === "success") {
							bootbox.alert(resp.data.msg);
							this.$router.go(-1);
						} else {
							bootbox.alert(resp.data.msg);
						}
					});
				} else {
					bootbox.alert("請確認必填欄位是否有填寫");
				}
			});
		},
		toDate(){
			let date = new Date();
			date.setDate(date.getDate() -1);
			return date;
		}
	},
	beforeRouteLeave(to, from, next) {
		this.removeStore(this.$route.name);
		next();
	}
};
</script>

<style scoped>
</style>
